import React from 'react'
import css from './style.scss'
import FacebookLogin from './index'
import {PopupPage} from 'components/container';
import api from "./api"


export default class PermissionsPopup extends React.Component{
  handleLogin=(response)=>{
    let data={
      token:response.accessToken,
      id:response.id
    }
    api.changeToken(data.token, data.id).then(()=>{
      this.props.onEveryThingIsBackToNormal()
    })
  }
  onError=(r)=>{
    console.log("permission error", r)
  }
  render(){
    return (
      <PopupPage width="medium" dontClose title="We need your help">
        <PermissionsComponent/>
        <FacebookLogin
           authType="rerequest"
           responseHandler={this.handleLogin}
           onPermissionError={this.onError}
           className={css.facebook_button}
           buttonText="Connect With Facebook"
        />
      </PopupPage>
    )
  }
}


export const PermissionsComponent=(props)=>(
  <div className={css.error}>
    <p>I'm sorry to bother you, but to fully work, <b>{process.env.REACT_APP_NAME}</b> needs these permissions from Facebook:</p>
    <ul>
      <li>Your email address</li>
      <li>Manage your Pages and show a list of the Pages you manage.</li>
      <li>Instagram business accounts connected to your page</li>
      <li>Access insights for the Instagram business accounts connected to your page</li>
    </ul>
    <p>Without these permissions <b>{process.env.REACT_APP_NAME}</b> is will not work as expected. Please connect again with Facebook. </p>
  </div>
)
//'



// WEBPACK FOOTER //
// ./src/components/shared/facebook/permissions.js